export default __webpack_public_path__ + "static/media/img_2.34d2290e.svg";